import React from 'react';

const Breadcrumb = ({ segments = [], title }) => (
  <nav aria-label="breadcrumbs p-0 m-0">
    <ol className="breadcrumb">
      {segments.map((segment, i) => {
        const key = `breadcrumb-${segment.name}-${i}`;
        if (segment.url) {
          return (
            <li className="breadcrumb-item" key={key}>
              <a href={segment.url}>{segment.name}</a>
            </li>
          );
        }

        // Only the final crumb is the page heading; earlier link-less crumbs
        // (e.g. "All Products") would otherwise each render their own h1.
        const isCurrentPage = i === segments.length - 1;

        return (
          <li className="breadcrumb-item active" key={key}>
            {isCurrentPage ? (
              <h1 suppressHydrationWarning>{title || segment.name}</h1>
            ) : (
              segment.name
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
